import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62e06e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-overlay" }
const _hoisted_2 = {
  key: 0,
  class: "app-sidebar"
}

import { ref, watch } from 'vue';

import { useSidebar } from '@/composables/useSidebar';

import SidebarContent from './SidebarContent.vue';

/**
 * STATE
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showSidebar = ref(false);

/**
 * COMPOSABLES
 */
const { setSidebarOpen } = useSidebar();

watch(showSidebar, () => {
  if (showSidebar.value) {
    document.body.classList.add('overflow-hidden');
  } else {
    document.body.classList.remove('overflow-hidden');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "overlay",
    appear: "",
    onAfterEnter: _cache[3] || (_cache[3] = ($event: any) => (showSidebar.value = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "sidebar",
          onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSidebarOpen)(false)))
        }, {
          default: _withCtx(() => [
            (showSidebar.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(SidebarContent, {
                    onClose: _cache[0] || (_cache[0] = ($event: any) => (showSidebar.value = false))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "app-sidebar_empty",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showSidebar.value = false))
        }, [
          _createVNode(_component_BalIcon, {
            name: "x",
            size: "lg",
            class: "flex fixed top-4 right-2 justify-center items-center text-white cursor-pointer close-icon"
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})